const DonationWidget = () => {
    'use strict';

    var widgets = document.querySelectorAll('.donation-widget');

    if (!widgets.length) {
        return;
    }

    widgets.forEach(function (form) {
        // Donation Types (Monthly and One-off)
        var typeInputs = form.querySelectorAll('.donation-widget__type-input');
        // Group of values within a type e.g. 10, 15, 30
        var amountGroup = form.querySelector('.donation-widget__amount-group');
        // Other donation amount input
        var otherInput = form.querySelector('.donation-widget__other-input');
        // Radio to select the 'Other' input
        var otherRadio = form.querySelector('.donation-widget__amount-input--other');
        // Wrao fir the 'Other input
        var otherWrap = form.querySelector('.donation-widget__other-option');
        // Message content for each individual donation amount
        var messageTarget = form.querySelector('.donation-widget__content');
        // image within the message content
        var imageElement = form.querySelector('.donation-widget__image');
        // wrap for the message and image content
        var contentWrap = form.querySelector('.donation-widget__wrap--content');
        // redirect url on submit
        var redirectUrl = form.getAttribute('data-redirect-url') || '';
        // check if sculpture
        var isSculpture = form.getAttribute('data-is-sculpture') === 'true';

        var monthlyAmounts = [];
        var oneOffAmounts = [];

        try {
            monthlyAmounts = JSON.parse(amountGroup.getAttribute('data-monthly')) || [];
            oneOffAmounts = JSON.parse(amountGroup.getAttribute('data-one-off')) || [];
        } catch (error) {
            monthlyAmounts = [];
            oneOffAmounts = [];
        }

        /**
         * Toggle the content block.
         *
         * @param {boolean} show Whether to show the content block.
         * @return {void}
         */
        function toggleContent(show) {
            if (!contentWrap) {
                return;
            }

            contentWrap.style.display = show ? '' : 'none';
        }

        /**
         * Get selected donation type.
         *
         * @return {string}
         */
        function getSelectedType() {
            var selected = form.querySelector('.donation-widget__type-input:checked');

            return selected ? selected.value : 'monthly';
        }

        /**
         * Get the storage key used to persist the donation widget state.
         *
         * @return {string}
         */
        function getStorageKey() {
            return 'donation-widget-state';
        }

        /**
         * Save the current donation widget state to session storage.
         *
         * @return {void}
         */
        function saveState() {
            var selectedAmount = form.querySelector('.donation-widget__amount-input:checked');

            var state = {
                type: getSelectedType(),
                amount:
                    selectedAmount &&
                    !selectedAmount.classList.contains('donation-widget__amount-input--other')
                        ? selectedAmount.value
                        : '',
                otherAmount: otherInput.value.trim(),
            };

            sessionStorage.setItem(getStorageKey(), JSON.stringify(state));
        }

        /**
         * Get the previously saved donation widget state.
         *
         * @return {Object|null}
         */
        function getSavedState() {
            try {
                var saved = sessionStorage.getItem(getStorageKey());

                return saved ? JSON.parse(saved) : null;
            } catch (error) {
                return null;
            }
        }

        /**
         * Update message text.
         *
         * @param {string} message Message.
         * @return {void}
         */
        function updateMessage(message) {
            if (!messageTarget) {
                return;
            }

            messageTarget.textContent = message || '';
        }

        /**
         * Update image attributes.
         *
         * @param {Object} image Image data.
         * @return {void}
         */
        function updateImage(image) {
            if (!imageElement || !image) {
                return;
            }

            if (image.src) {
                imageElement.setAttribute('src', image.src);
            }

            if (image.srcset) {
                imageElement.setAttribute('srcset', image.srcset);
            } else {
                imageElement.removeAttribute('srcset');
            }

            if (image.sizes) {
                imageElement.setAttribute('sizes', image.sizes);
            } else {
                imageElement.removeAttribute('sizes');
            }

            imageElement.setAttribute('alt', image.alt || '');
        }

        /**
         * Update content from selected preset input.
         *
         * @param {HTMLElement} input Amount input.
         * @return {void}
         */
        function updateFromInput(input) {
            if (!input) {
                return;
            }

            var message = input.getAttribute('data-message') || '';

            updateMessage(message);
            updateImage({
                src: input.getAttribute('data-image-src') || '',
                alt: input.getAttribute('data-image-alt') || '',
            });

            toggleContent(message.trim() !== '');
        }

        /**
         * Clear other amount state.
         *
         * @return {void}
         */
        function clearOtherSelection() {
            otherRadio.checked = false;
            otherRadio.value = '';
            otherInput.value = '';
            otherWrap.classList.remove('is-selected');
        }

        /**
         * Select other amount.
         *
         * @return {void}
         */
        function selectOtherAmount() {
            var value = otherInput.value.trim();

            form.querySelectorAll(
                '.donation-widget__amount-input:not(.donation-widget__amount-input--other)'
            ).forEach(function (input) {
                input.checked = false;
            });

            otherRadio.checked = true;
            otherRadio.value = value;
            otherWrap.classList.add('is-selected');

            updateMessage('');
            toggleContent(false);
        }

        /**
         * Build amount option markup.
         *
         * @param {Object} row Amount row.
         * @param {number} index Index.
         * @param {boolean} checked Checked state.
         * @return {string}
         */
        function buildAmountOption(row, index, checked) {
            var amount = row && row.content ? row.content : '';
            var message = row && row.message ? row.message : '';
            var image = row && row.image ? row.image : {};
            var id = 'donation-amount-' + getSelectedType() + '-' + index;

            return (
                '<label class="donation-widget__amount-option">' +
                '<input' +
                ' type="radio"' +
                ' name="donation_amount"' +
                ' value="' +
                amount +
                '"' +
                ' id="' +
                id +
                '"' +
                ' class="donation-widget__amount-input"' +
                ' data-message="' +
                (message || '').replace(/"/g, '&quot;') +
                '"' +
                ' data-image-src="' +
                (image.src || '').replace(/"/g, '&quot;') +
                '"' +
                ' data-image-srcset="' +
                (image.srcset || '').replace(/"/g, '&quot;') +
                '"' +
                ' data-image-sizes="' +
                (image.sizes || '').replace(/"/g, '&quot;') +
                '"' +
                ' data-image-alt="' +
                (image.alt || '').replace(/"/g, '&quot;') +
                '"' +
                (checked ? ' checked' : '') +
                '>' +
                '<span class="donation-widget__amount-text">£' +
                amount +
                '</span>' +
                '</label>'
            );
        }

        /**
         * Render donation amounts for the selected type and restore the selected amount.
         *
         * @param {string} type Donation type.
         * @param {string} selectedAmount Previously selected donation amount.
         * @return {void}
         */
        function renderAmounts(type, selectedAmount) {
            var rows = type === 'one-off' ? oneOffAmounts : monthlyAmounts;
            var firstRow = rows.length ? rows[0] : null;
            var markup = '';

            rows.forEach(function (row, index) {
                var amount = row && row.content ? String(row.content) : '';
                var checked = selectedAmount ? amount === String(selectedAmount) : index === 0;

                markup += buildAmountOption(row, index, checked);
            });

            amountGroup.innerHTML = markup;

            if (otherInput.value.trim() !== '') {
                otherInput.value = '';
            }

            otherRadio.checked = false;
            otherRadio.value = '';
            otherWrap.classList.remove('is-selected');

            var selectedPreset = form.querySelector('.donation-widget__amount-input:checked');

            if (selectedPreset) {
                updateFromInput(selectedPreset);
            } else if (firstRow) {
                updateMessage(firstRow.message);
                updateImage(firstRow.image);
                toggleContent(firstRow.message && firstRow.message.trim() !== '');
            } else {
                updateMessage('');
                toggleContent(false);
            }
        }

        /**
         * Sync UI from current selection.
         *
         * @return {void}
         */
        function syncFromSelection() {
            var selectedPreset = form.querySelector('.donation-widget__amount-input:checked');

            if (selectedPreset && selectedPreset.value !== '') {
                updateFromInput(selectedPreset);
                return;
            }

            if (otherInput.value.trim() !== '') {
                updateMessage('');
                toggleContent(false);
                return;
            }

            updateMessage('');
            toggleContent(false);
        }

        typeInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                renderAmounts(this.value);
                saveState();
            });
        });

        window.addEventListener('pageshow', function () {
            var savedState = getSavedState();

            if (!savedState) {
                syncFromSelection();
                return;
            }

            var typeInput = form.querySelector(
                '.donation-widget__type-input[value="' + savedState.type + '"]'
            );

            if (typeInput) {
                typeInput.checked = true;
            }

            renderAmounts(savedState.type || 'Monthly', savedState.amount || '');

            if (savedState.otherAmount) {
                otherInput.value = savedState.otherAmount;
                selectOtherAmount();
            }
        });

        form.addEventListener('change', function (event) {
            if (
                event.target.classList.contains('donation-widget__amount-input') &&
                !event.target.classList.contains('donation-widget__amount-input--other')
            ) {
                clearOtherSelection();
                updateFromInput(event.target);
                saveState();
            }
        });

        otherInput.addEventListener('focus', function () {
            selectOtherAmount();
        });

        otherInput.addEventListener('input', function () {
            if (this.value.trim() !== '') {
                selectOtherAmount();
            } else {
                otherRadio.checked = false;
                otherRadio.value = '';
                otherWrap.classList.remove('is-selected');
                syncFromSelection();
            }

            saveState();
        });

        form.addEventListener('submit', function (event) {
            var selectedAmount = form.querySelector('input[name="donation_amount"]:checked');
            var isOtherAmount =
                selectedAmount &&
                selectedAmount.classList.contains('donation-widget__amount-input--other');
            var type = getSelectedType();
            var amount = '';
            var url;

            event.preventDefault();

            if (isOtherAmount) {
                amount = otherInput.value.trim();
            } else if (selectedAmount) {
                amount = selectedAmount.value;
            }

            if (!amount || parseFloat(amount) <= 0) {
                otherInput.focus();
                return;
            }

            url = new URL(redirectUrl, window.location.origin);

            if (!isSculpture) {
                url.searchParams.set('donation_type', 'personal');
                url.searchParams.set('donation_frequency', type);

                if (isOtherAmount) {
                    url.searchParams.set('donation_amount', 'other');
                    url.searchParams.set('other_amount', amount);
                } else {
                    url.searchParams.set('donation_amount', amount);
                }
            }

            window.location.href = url.toString();
        });

        var savedState = getSavedState();

        if (savedState) {
            var savedTypeInput = form.querySelector(
                '.donation-widget__type-input[value="' + savedState.type + '"]'
            );

            if (savedTypeInput) {
                savedTypeInput.checked = true;
            }

            renderAmounts(savedState.type || 'Monthly', savedState.amount || '');

            if (savedState.otherAmount) {
                otherInput.value = savedState.otherAmount;
                selectOtherAmount();
            }
        } else {
            syncFromSelection();
        }
    });
};

export default DonationWidget;
